<script setup lang="ts">
definePageMeta({
  title: 'Forgd',
  supportsMobile: true,
  noPadding: true,
  allowPreLogin: true,
})
</script>

<template>
  <HomeLanding />
</template>
